////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { isEmpty } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
///////COMPONENTS///////
import { uriList } from '../../routings/settings/RouteList'
/////////ASSETS/////////
import LogoBackground from '../../assets/images/maintenance/maintenance-logo.svg'
import LogoWD from '../../assets/images/logo-we-deal-white.svg'
import WipMaintenance from '../../assets/images/maintenance-in-progress-white.svg'

/////////STYLED/////////
const MaintenanceWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	background-color: ${(props) => props.theme.colors.primary};
	overflow: hidden;
	min-width: 560px;
	min-height: 780px;
`
const ImgBackground = styled.div`
	position: absolute;
	bottom: -300px;
	left: -300px;
	overflow: hidden;
	z-index: 5;
`
const LogoWdImg = styled.img`
	height: 90px;
	margin-bottom: 75px;
`
const Title = styled.div`
	font-weight: bold;
	font-size: 30px;
	margin-top: ${(props) => (props.second ? '20px' : 'inherit')};
	color: ${(props) => props.theme.colors.white};
`
const BodyText = styled.div`
	font-size: 16px;
	font-style: italic;
	color: ${(props) => props.theme.colors.white};
	margin-top: 15px;
	margin-bottom: 100px;
`
const WipImg = styled.img`
	max-width: 430px;
`
/////////STYLED/////////

const Maintenance = () => {
	let history = useHistory()

	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!isEmpty(translations)) {
			history.push(uriList.login)
		}
	}, [translations])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<MaintenanceWrapper>
			<ImgBackground>
				<img src={LogoBackground} alt="" />
			</ImgBackground>

			<LogoWdImg src={LogoWD} alt="" />
			<Title>- APPLICATION EN MAINTENANCE -</Title>
			<Title second>- MAINTENANCE IN PROGRESS -</Title>
			<BodyText>Merci de votre patience</BodyText>
			<WipImg src={WipMaintenance} />
		</MaintenanceWrapper>
	)
}

Maintenance.propTypes = {}

Maintenance.defaultPropTypes = {}

export default Maintenance
